import { render, staticRenderFns } from "./ContactManageView.vue?vue&type=template&id=2de64e30&scoped=true&"
import script from "./ContactManageView.vue?vue&type=script&lang=js&"
export * from "./ContactManageView.vue?vue&type=script&lang=js&"
import style0 from "./ContactManageView.vue?vue&type=style&index=0&id=2de64e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de64e30",
  null
  
)

export default component.exports